import { Children, isValidElement, type ReactElement, type ReactNode } from 'react';

/*
 * Children.toArray normalizes every shape callers pass as options — a single element, an array,
 * nested arrays, fragments. Elements without a `value` (wrappers, group headings) are not
 * selectable, so they are dropped, mirroring how Select.Option treats `value === undefined`.
 */
export const getOptionElements = <T>(children: ReactNode) =>
  Children.toArray(children).filter((child): child is ReactElement<{ value: T | null }> =>
    isValidElement<{ value?: T | null }>(child) ? child.props.value !== undefined : false,
  );
